import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminClinicBlock from 'components/templates/admin/clinic';

const AdminClinic = () => {
  const { clinicGuid } = useParams();
  const {
    adminPanelClinics: { getClinic, getThreshold },
  } = useDispatch();
  useEffect(() => {
    getClinic(clinicGuid);
    getThreshold(clinicGuid);
  }, []);
  return (
    <Container>
      <AdminHeader />
      <AdminClinicBlock />
    </Container>
  );
};

export default AdminClinic;
